import React from "react";
import { toElementProps } from "../../Element.js";

export function BlockHeaderContentStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-header-content": {
            display: "grid",
            gridGap: "40px",

            [MobileBreakpoint]: {
                paddingLeft: "36px",
                paddingRight: "36px",
                gridGap: "40px !important",
                display: "grid !important",
            },

            "&.image-text, &.text-image": {
                gridTemplateColumns: "1fr 1fr",
                alignItems: "center",

                [MobileBreakpoint]: {
                    gridTemplateColumns: "1fr",
                    alignItems: "center",
                },
            },

            "&.image-text-down": {
                [MobileBreakpoint]: {
                    "& .block:nth-child(1)": {
                        gridRow: 2,
                    },
                },
            },

            "&.image-text-up": {
                [MobileBreakpoint]: {
                    "& .block:nth-child(1)": {
                        gridRow: 1,
                    },
                },
            },
        },
    };
}

export default function BlockHeaderContent(props) {
    const BHCP = props.BlockHeaderContentPosition || props.variables.info?.BlockHeaderContentPosition; // Layouts.js -> Header()
    const CNBlockContent = ["block-header-content", BHCP];
    const ProductUp = props.variables.info?.ProductUp;

    if (ProductUp) {
        BHCP === "text-image" ? CNBlockContent.push("image-text-down") : CNBlockContent.push("image-text-up");
    } else {
        BHCP === "image-text" && CNBlockContent.push("image-text-down");
    }

    const elProps = toElementProps(props, { className: CNBlockContent });
    return <div {...elProps}>{props.children}</div>;
}
